exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(true);
// Imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Rubik&display=swap);", ""]);
// Module
exports.push([module.id, "._3NqNuAzSVrYf1o1-dIYQUW {\n  font-family: 'Rubik', sans-serif;\n}", "",{"version":3,"sources":["DocContainer.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC","file":"DocContainer.css","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Rubik&display=swap');\n\n.background {\n  font-family: 'Rubik', sans-serif;\n}"]}]);
// Exports
exports.locals = {
	"background": "_3NqNuAzSVrYf1o1-dIYQUW"
};